const defaultFileNameExp = '${_table.name}'

export default {
  DEFAULT_OUTPUT_PATH: 'codes',
  PROJECT_NAME: '${_systemEnName}',
  RERENDER_TREE_TIME: 600, // 重新渲染树时间
  DEFAULT_FILENAME_EXP: defaultFileNameExp, // 默认文件名表达式
  // 系统关键字（用于客户端命令）
  Keywords: ['project', 'token', 'db', 'database', 'template', 'user', 'init', 'table', 'login', 'logout', 'regis', 'register', 'change', 'exec', 'search', 'install', 'run', 'add', 'remove', 'delete'],
  // 生成周期
  GenCycle: {
    GROUP_BUILDING: 'ONCE', // 构建周期
    MODULE_LOOP: 'MODULE', // 数据周期
    INHERIT: 'INHERIT' // 继承（目录设置时可用）
  },
  // 属性类型
  PropType: {
    TEXT: 'TEXT',
    TEXTAREA: 'TEXTAREA',
    SELECT_MULTIPLE: 'SELECT_MULTIPLE',
    SELECT_SINGLE: 'SELECT_SINGLE',
    BOOLEAN: 'BOOLEAN',
    NUMBER: 'NUMBER'
  },
  // 系统属性
  SystemProp: {
    file_name_exp: {
      frontNo: '100001',
      code: 'file_name_exp',
      name: '输出文件名',
      defaultValue: defaultFileNameExp,
      variableName: '_fileName',
      description: '输出文件名表达式'
    },
    file_output_path: {
      frontNo: '100002',
      code: 'template_output_path',
      name: '输出路径',
      variableName: '_templateOutputPath',
      description: '文件输出路径'
    }
  },
  // 空元数据项
  EMPTY_SOURCEDATA_ROW: {
    name: '', // 名称
    originName: '', // 原始名称
    type: 'TEXT', // 数据类型
    originType: '', // 原始类型
    length: 0, // 数据长度
    decimal: 0, // 小数位长度
    isPrimaryKey: false, // 是否主键
    isAutoIncrement: false, // 是否自动增长
    required: false, // 是否必填
    isUnique: false, // 是否唯一
    defaultValue: null, // 默认值
    remark: '', // 数据备注
    isEnable: true // 是否禁用
  },
  // 空全局属性
  EMPTY_GLOBAL_PROP: {
    id: null, // 属性ID
    frontNo: null, // 前端编号
    name: '', // 属性名
    variableName: '', // 变量
    description: '',
    inputType: 'TEXT', // 输入类型
    defaultValue: '', // 默认值
    required: false, // 是否必填
    isShow: true, // 是否显示
    isShowLogic: '', // 是否显示逻辑
    items: [] // 属性选项
  },
  // 空模版属性
  EMPTY_PROP: {
    id: null, // 属性ID
    frontId: null, // 前端编号
    name: '',
    variableName: '', // 变量
    value: '', // 值
    description: ''
  },
  // 空数据属性
  EMPTY_DATA_PROP: {
    id: null, // 属性ID
    frontNo: null, // 前端编号
    name: '', // 属性名
    variableName: '', // 变量
    description: '',
    inputType: 'TEXT', // 输入类型
    defaultValue: '', // 默认值
    required: false, // 是否必填
    isShow: true, // 是否显示
    isShowLogic: '', // 是否显示逻辑
    items: [] // 属性选项
  }
}
